import { useSpacePermissions } from '../../../../hooks/useSpacePermissions/useSpacePermissions';
import { SpaceReadModel, BuildingReadModel, PermissionKeys } from '@client/api';
import { useTranslation } from 'react-i18next';
import { Button } from '@client/toolkit';

export function SpacePermissionBasedCta({
  space,
  loading,
  handleEditClick,
  handleDeleteClick,
  handleDuplicateClick,
  editModal,
  deleteModal,
  duplicateModal,
  canDuplicate = false,
}: {
  space: BuildingReadModel | SpaceReadModel | undefined;
  loading: boolean;
  handleEditClick: () => void;
  handleDeleteClick: () => void;
  handleDuplicateClick?: () => void;
  editModal: React.ReactNode;
  deleteModal: React.ReactNode;
  duplicateModal?: React.ReactNode;
  canDuplicate?: boolean;
}) {
  const { t: tCommon } = useTranslation();
  const { hasAnyPermission } = useSpacePermissions({ id: space?.id });

  if (!space || loading) return null;

  return (
    <>
      {hasAnyPermission([PermissionKeys.Space.Update]) && (
        <>
          <Button
            color="primary-dark"
            disabledVariant="dark"
            fontSize="sm"
            disabled={loading}
            onClick={handleEditClick}
          >
            {tCommon('edit')}
          </Button>
          {editModal}
        </>
      )}
      {canDuplicate && handleDuplicateClick && hasAnyPermission([PermissionKeys.Space.Update]) && (
        <>
          <Button
            color="primary-dark"
            disabledVariant="dark"
            fontSize="sm"
            disabled={loading}
            onClick={handleDuplicateClick}
          >
            {tCommon('duplicate')}
          </Button>
          {duplicateModal}
        </>
      )}
      {hasAnyPermission([PermissionKeys.Space.Delete]) && (
        <>
          <Button
            color="primary-dark"
            disabledVariant="dark"
            fontSize="sm"
            disabled={loading}
            onClick={handleDeleteClick}
          >
            {tCommon('delete')}
          </Button>
          {deleteModal}
        </>
      )}
    </>
  );
}
